export { default } from './SizeChart'
